import FormAddPost from './FormAddPost'
import Posts from './Posts'


const Main = () => {
    return (
        <main>
            <FormAddPost />
            <Posts />
        </main>
    )
}

export default Main